import type { Config } from "../../common/interfaces/config";

export type TokenValidationResponse = {
  isImpersonation: boolean;
};

const isTokenValidationResponse = (value: unknown): value is TokenValidationResponse =>
  typeof value === "object" &&
  value !== null &&
  "isImpersonation" in value &&
  typeof value.isImpersonation === "boolean";

export const fetchTokenValidation = async (token: string, config: Config): Promise<TokenValidationResponse> => {
  const tokenApiBasePath = config.apiBasePaths?.oktaToken;
  if (!tokenApiBasePath) {
    throw new Error("Missing Okta token API configuration");
  }

  const response = await fetch(`${config.apiBaseUrl}${tokenApiBasePath}/token-validation`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    throw new Error(`Token validation returned ${response.status}`);
  }

  const data: unknown = await response.json();
  if (!isTokenValidationResponse(data)) {
    throw new Error("Missing isImpersonation in token validation response");
  }

  return data;
};
